export var Tipo;
(function (Tipo) {
    Tipo[Tipo["STRING"] = 0] = "STRING";
    Tipo[Tipo["ETIQUETA"] = 1] = "ETIQUETA";
    Tipo[Tipo["ATRIBUTO"] = 2] = "ATRIBUTO";
    Tipo[Tipo["ETIQUETA_UNIQUE"] = 3] = "ETIQUETA_UNIQUE";
    Tipo[Tipo["XQ_VAR"] = 4] = "XQ_VAR";
    Tipo[Tipo["XQ_FUNC"] = 5] = "XQ_FUNC";
    Tipo[Tipo["XQ_NUMB"] = 6] = "XQ_NUMB";
})(Tipo || (Tipo = {}));
